import { createRouter, createWebHistory } from "vue-router";
import HomePage from "../pages/HomePage.vue";
import { setRouteSeo } from "../utils/seo";

const CasesPage = () => import(/* webpackChunkName: "community" */ "../pages/CasesPage.vue");
const WorkDetailPage = () => import(/* webpackChunkName: "community" */ "../pages/WorkDetailPage.vue");
const StudioPage = () => import(/* webpackChunkName: "studio" */ "../pages/StudioPage.vue");
const CollectionPage = () => import(/* webpackChunkName: "collection" */ "../pages/CollectionPage.vue");
const GachaPage = () => import(/* webpackChunkName: "collection" */ "../pages/GachaPage.vue");
const ProfilePage = () => import(/* webpackChunkName: "account" */ "../pages/ProfilePage.vue");
const MembershipPage = () => import(/* webpackChunkName: "account" */ "../pages/MembershipPage.vue");

const routes = [
  { path: "/", name: "home", component: HomePage, meta: { title: "首页", description: "拼豆物语提供在线图片转拼豆图纸、品牌色号匹配、2D/3D 成品预览和作品社区。" } },
  { path: "/cases", name: "cases", component: CasesPage, meta: { title: "发现", description: "发现优质拼豆作品、配色灵感和可复刻的拼豆图纸。" } },
  { path: "/works/:id", name: "work-detail", component: WorkDetailPage, meta: { title: "作品详情", description: "查看拼豆作品详情、用豆信息和 2D/3D 成品效果。" } },
  { path: "/studio", name: "studio", component: StudioPage, meta: { title: "在线创作", description: "上传图片，一键生成带色号、用量统计和网格的拼豆图纸。" } },
  { path: "/collection", name: "collection", component: CollectionPage, meta: { title: "图鉴", description: "收集拼豆角色、查看收藏进度并分享你的拼豆图鉴。" } },
  { path: "/gacha", name: "gacha", component: GachaPage, meta: { title: "幸运扭蛋机" } },
  { path: "/profile", name: "profile", component: ProfilePage, meta: { title: "我的主页" } },
  { path: "/membership", name: "membership", component: MembershipPage, meta: { title: "创作会员" } }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior() {
    return { top: 0 };
  }
});

router.afterEach((to) => {
  setRouteSeo(to);
});

export default router;
